<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11Ahca1/tc-custom/9781452159355.jpg?1740428357309" alt="This image is the cover for the book Energy Balls"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Energy Balls
      </h1>
      <p class="bookDescription body article font2">
        <b>Vegan, no-bake, gluten-free, bite-sized eats for breakfast, lunch, and anytime you need a brain or body boost—or even a relaxing bedtime snack.</b><br/>  <br/> This little cookbook packs a big punch with 100 delicious recipes for no-bake energy balls designed to deliver a targeted blast of energy for different activities at any hour. Crafted with whole ingredients, superfoods, and all-natural proteins, each vegan and gluten-free bite-size treat offers the perfect nutritional boost. Extra protein, nuts, and seeds give athletes a high-energy hit; dark chocolate and green tea help students concentrate and focus; ginger lets the overstressed wind down at the end of a long day. And, kids will love them tucked into their lunch boxes. They are as easy to make as they are good to eat—good-bye processed and packaged sports bars! 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christal Sczebel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7fc1f476